import { Controller } from '@hotwired/stimulus';

const normalize = (text) => text
  .normalize('NFKC')
  .replace(/[ぁ-ゖ]/g, (char) => String.fromCharCode(char.charCodeAt(0) + 0x60))
  .replace(/\s+/g, '')
  .toLowerCase();

export default class extends Controller {
  static targets = ['list', 'hint'];

  match(event) {
    const text = normalize(event.target.value);
    let shown = 0;

    this.hintTargets.forEach((hint) => {
      const keywords = hint.dataset.keywords.split(' ').map(normalize);
      const hit = text.length > 0 && keywords.some((keyword) => text.includes(keyword));
      hint.classList.toggle('d-none', !hit);
      if (hit) { shown += 1; }
    });

    this.listTarget.classList.toggle('d-none', shown === 0);
  }
}
